export enum ProgressNodeFocusEnum {
  inactive,
  active,
  seen,
}
